import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-minus-faq",
  "use": "icon-minus-faq-usage",
  "viewBox": "0 0 16 1.6",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 1.6\" id=\"icon-minus-faq\">\n  <path id=\"icon-minus-faq_np_minus_705084_000000\" d=\"M20.8,47a.8.8,0,1,0,0,1.6H35.2a.8.8,0,0,0,0-1.6Z\" transform=\"translate(-20 -47)\" fill=\"#695225\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./assets/svg/minus-faq.svg
// module id = 149
// module chunks = 0 1 2